import React from 'react';
import { Link } from 'react-router-dom';
import { SITE_CONTENT } from '../content';

const FeaturesSection = () => {
  const features = SITE_CONTENT.pages?.homePage?.featuresSection?.features || [];
  return (
    <section className="bg-[#f0ebe0] py-20 lg:py-28">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 lg:gap-16">
          {features.map((item, idx) => (
            <div
              key={idx}
              className="flex flex-col items-center text-center group"
            >
              {/* Large outlined number */}
              <span
                className="text-[7rem] lg:text-[9rem] font-light leading-none select-none mb-4"
                style={{
                  color: 'transparent',
                  WebkitTextStroke: '1.5px #c8c0b0',
                  fontFamily: "'Manrope', sans-serif",
                  letterSpacing: '-0.02em',
                  transition: 'all 0.4s ease',
                }}
              >
                {item.number}
              </span>

              {/* Title */}
              <h3 className="text-[#1a2e1a] text-lg font-semibold tracking-wide mb-3">
                {item.title}
              </h3>

              {/* Description */}
              <p className="text-[#6b6b5a] text-sm leading-relaxed max-w-[240px] mb-7">
                {item.description}
              </p>

              {/* CTA Button */}
              <Link
                to={item.to}
                className="px-6 py-2.5 bg-[#1a2e1a] text-white text-xs tracking-[0.15em] uppercase font-medium rounded-full hover:bg-[#2d4a2d] transition-all duration-300 hover:scale-105 shadow-md hover:shadow-[#1a2e1a]/30"
              >
                {item.cta}
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
